import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './SalesOrders.frontend.types'

@Injectable({ providedIn: 'root' })
export class SalesOrders_copy_sales_order_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { orderId: number, copyAddresses: boolean }): Promise<{ newOrderId?: number, reason?: string, newShipmentId?: number, orderId?: number }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.orderId)) {
      $missingRequiredInParams.push('\'orderId\'');
    }
    if (isNil($inParams.copyAddresses)) {
      $missingRequiredInParams.push('\'copyAddresses\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

